import React, { useEffect, useState } from 'react';

import AffiliateCouponsForm from 'components/AffiliateCouponsForm/AffiliateCouponsForm';

const REMOVED_AFFILIATE_STORAGE_KEY = 'removedAffiliateCoupons';
const PUBLISHED_AFFILIATE_STORAGE_KEY = 'publishedAffiliateCoupons'

const AffiliateCouponsList = ({
  coupons = [],
  loading,
  productImages = [],
  onImageChange = null,
  skipLocalStoragePublished,
  ...props
}) => {
  const [displayedCoupons, setDisplayedCoupons] = useState([]);

  useEffect(() => {
    const now = new Date();

    // Use Sets for O(1) average lookup time when filtering removed
    // and previously published affiliate coupons.
    const removedCoupons = new Set(
      JSON.parse(
        localStorage.getItem(REMOVED_AFFILIATE_STORAGE_KEY) || '[]'
      )
    );

    const publishedCoupons = new Set(
      JSON.parse(
        localStorage.getItem(PUBLISHED_AFFILIATE_STORAGE_KEY) || '[]'
      )
    );

    setDisplayedCoupons(
      coupons.filter((coupon) => {
        // Filter expired coupons
        if (
          coupon.expiration_date &&
          new Date(coupon.expiration_date) <= now
        ) {
          return false;
        }

        const key = coupon.title || coupon.description;

        // Filter removed and already published coupons
        if (!key) {
          return false;
        }
// skipLocalStoragePublished comes from AffiliateCouponViewer
// AffiliateCouponViewer displays published affiliate coupons, so skip
// filtering against the published coupons stored in localStorage.
        return (
          !removedCoupons.has(key) &&
          (skipLocalStoragePublished || !publishedCoupons.has(key))
        );
      })
    );
  }, [coupons, skipLocalStoragePublished]);

  const handleRemove = (localId) => {
    const coupon = displayedCoupons.find(
      (coupon) => coupon.localId === localId
    );

    if (coupon) {
      const key = coupon.title || coupon.description;

      if (key) {
        const removedCoupons = new Set(
          JSON.parse(localStorage.getItem(REMOVED_AFFILIATE_STORAGE_KEY) || '[]')
        );

        removedCoupons.add(key);

        localStorage.setItem(
          REMOVED_AFFILIATE_STORAGE_KEY,
          JSON.stringify([...removedCoupons])
        );
      }
    }

    setDisplayedCoupons((prev) =>
      prev.filter((coupon) => coupon.localId !== localId)
    );
  };

  if (loading) return null;

  return (
    <>
      {displayedCoupons.map((coupon, index) => (
        <AffiliateCouponsForm
          key={coupon.localId}
          coupon={coupon}
          index={index}
          productImages={productImages}
          onImageChange={onImageChange}
          handleRemove={() => handleRemove(coupon.localId)}
          {...props}
        />
      ))}
    </>
  );
};

export default AffiliateCouponsList;